// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-active: #2299ff;
}

.themeSelector {
  margin-bottom: 4px;
  z-index: 999;
  border-radius: 10px;
  display: flex;
  gap: 4px;
  justify-content: end;
  align-items: center;
}

.toolbarItem {
  position: relative;
  cursor: pointer;
  margin: 0 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  color: inherit;
  font: inherit;
}

/* Visually hidden but still in the tab order / label activation (display:none can break change in some cases) */
.toolbarItem > input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
  opacity: 0;
}

.toolbarItem > input:not(:checked) + span,
.toolbarItem[data-on='false'] > span {
  opacity: 0.6;
}

.toolbarItem > input:checked + span,
.toolbarItem[data-on='true'] > span {
  color: var(--color-active);
}

.toolbarItem:hover > span {
  opacity: 1;
}

.toolbarItem[data-on='false']:hover > span {
  color: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/components/ThemeSelector/style.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,aAAa;AACf;;AAEA,gHAAgH;AAChH;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB","sourcesContent":[":root {\n  --color-active: #2299ff;\n}\n\n.themeSelector {\n  margin-bottom: 4px;\n  z-index: 999;\n  border-radius: 10px;\n  display: flex;\n  gap: 4px;\n  justify-content: end;\n  align-items: center;\n}\n\n.toolbarItem {\n  position: relative;\n  cursor: pointer;\n  margin: 0 2px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n}\n\n/* Visually hidden but still in the tab order / label activation (display:none can break change in some cases) */\n.toolbarItem > input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n  opacity: 0;\n}\n\n.toolbarItem > input:not(:checked) + span,\n.toolbarItem[data-on='false'] > span {\n  opacity: 0.6;\n}\n\n.toolbarItem > input:checked + span,\n.toolbarItem[data-on='true'] > span {\n  color: var(--color-active);\n}\n\n.toolbarItem:hover > span {\n  opacity: 1;\n}\n\n.toolbarItem[data-on='false']:hover > span {\n  color: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"themeSelector": `themeSelector`,
	"toolbarItem": `toolbarItem`
};
export default ___CSS_LOADER_EXPORT___;
